export const CompanyDocumentLabels: string[] = ['REPORTING_ACCOUNTING'];

export const DocumentLabelDescriptions = new Map([
    ['REPORTING_ACCOUNTING', $localize`Report Accounting`],
    ['PAPER_PENCIL_QUESTIONNAIRE', $localize`Paper & Pencil questionnaire`],
    ['PGBU_EVALUATION', $localize`Evaluation`]
]);
